import { createFileRoute } from "@tanstack/react-router"

/*
  PAM sends drivers here; the parent guard redirects them to the cart, which
  fetches the welcome token. Move the welcome query if you remove this route.
*/

export const Route = createFileRoute(
  "/qr/$qrLookupID/gated/$pamID/$sessionID/"
)({})
